import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';
import { CursoModel, ResponsePaginated } from '../models';
import { map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { Helpers } from '@core/helpers/helpers';

@Injectable({
  providedIn: 'root',
})
export class CursoService {
  constructor(
    private apiService: ApiService,
    private helper: Helpers
  ) { }
  context = '/cursos';

  add(curso: any): Observable<any> {
    return this.apiService.post(`${this.context}`, curso).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getAll(params: HttpParams): Observable<ResponsePaginated<CursoModel[]>> {
    return this.apiService.get(`${this.context}`, params);
  }

  getById(id: string): Observable<any> {
    return this.apiService.get(`${this.context}/${id}`);
  }

  getByUtilizador(userId: number) {
    return this.apiService.get(`${this.context}/meus-cursos/${userId}/`);
  }

  update(curso: any): Observable<any> {
    const { id } = curso;
    return this.apiService.put(`${this.context}/${id}`, curso).pipe(
      map((data) => {
        return data.curso;
      })
    );
  }

  delete(id: string) {
    return this.apiService.delete(`${this.context}/${id}`).pipe(
      map((data) => {
        return data;
      })
    );
  }


  downloadAnexo(id: string): Observable<any> {
    return this.apiService.get(`/anexos/${id}/download?key=${encodeURIComponent(this.helper.generateApplicationHash())}`);
  }

}
